import { OrderedMap, Record } from 'immutable';
const CategoryOrganization = Record({
  categories: OrderedMap(),
  error: undefined,
  isCreating: false,
  isRequesting: false,
  isUpdating: false,
  isOrdering: false,
  lastCreated: null,
  lastLoaded: null,
  lastUpdated: undefined,
  orderingSuccess: undefined,
  requestedLanguage: undefined,
  primaryLanguage: undefined,
  translatedParentCategories: undefined
});
export default CategoryOrganization;